// extracted by mini-css-extract-plugin
export default {"root":"X7CgU","label":"vRTHM"};